'use strict';

(function() {
  const module = angular.module('client.components');

  module.component('signup', {
    template: require('./signup.jade'),
  });
})();
